module.exports = __webpack_public_path__ + "img/miniMe.4c6996e3.svg";